<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Daşınmaz əmlak satışından verginin hesablanması</h1>
        <div class="note">
          <p>Vergi Məcəlləsinin 218-ci maddəsinə edilmiş dəyişikliklərə əsasən mülkiyyətində olan yaşayış və qeyri-yaşayış sahələrini təqdim edən şəxslər 1 yanvar 2016-cı ildən etibarən notarius tərəfindən ödəmə mənbəyində sadələşdirilmiş vergiyə cəlb olunur.</p>
          <p>Aşağıdakı hallarda yaşayış və qeyri-yaşayış sahələrinin təqdim edilməsindən vergi tutulmur:</p>
          <ul>
            <li>fiziki şəxsin azı 5 il ərzində yaşayış yeri üzrə qeydiyyatda olduğu yaşayış sahələrinin təqdim edilməsi,</li>
            <li>daşınmaz əmlakın hədiyyə, maddi yardım və miras formasında ailə üzvləri tərəfindən verilməsi,</li>
            <li>daşınmaz əmlakın dövlət ehtiyacları üçün alınması,</li>
            <li>əmlakın ər və arvad arasında verilməsi, keçmiş ər-arvad arasında boşanma prosesində verilməsi.</li>
          </ul>
        </div>
      </div>
      
      <div class="col-md-6">
        <p>Təyinatı:</p>
        <select v-model="assignment" @change="calc">
          <option value="1">yaşayış</option>
          <option value="1.5">qeyri-yaşayış</option>
        </select>
      </div>

      <div class="col-md-6">
        <p>Binanın yerləşdiyi zona:</p>
        <select v-model="zone" @change="calc">
          <option value="4.0">zona 1</option>
          <option value="3.0">zona 2</option>
          <option value="2.2">zona 3</option>
          <option value="2.2">zona 4</option>
          <option value="1.8">zona 5</option>
          <option value="1.8">zona 6</option>
          <option value="1.5">zona 7</option>
          <option value="1.5">zona 8</option>
          <option value="1.5">zona 9</option>
          <option value="1.2">zona 10</option>
          <option value="1.2">zona 11</option>
          <option value="1.2">zona 12</option>
          <option value="1.2">Abşeron rayonunun qəsəbə və kəndləri</option>
          <option value="1.5">Gəncə, Sumqayıt və Xırdalan</option>
          <option value="1.2">Şirvan, Mingəçevir, Naxçıvan, Lənkəran, Yevlax, Şəki və Naftalan</option>
          <option value="0.5">digər rayon (şəhər) və qəsəbələr (kəndlər)</option>
        </select>
      </div>

      <div class="col-md-6">
        <p>Daşınmaz əmlakın sahəsi, m<sup>²</sup>:</p>
        <input type="number" v-model="area" placeholder="0" @input="calc">
      </div>

      <div class="col-md-6">
        <p>Vergi məbləği:</p>
        <input type="text" v-model="price" placeholder="0.00 AZN" disabled>
      </div>
      
      <div class="col-12">
        <p class="note">Bakı şəhəri üzrə müəyyən edilən zonalar və onların sərhədləri haqqında məlumatı <a href="http://www.e-qanun.az/framework/29860" target="_blank">buradan</a> öyrənə bilərsiniz.</p>
        <p class="note">Yaşayış və qeyri-yaşayış sahələrinin təqdim edilməsi üzrə sadələşdirilmiş vergi alqı-satqı müqavilələrini təsdiq edən notarius tərəfindən hesablanaraq tutulur, 1 (bir) bank günü ərzində dövlət büdcəsinə ödənilir və bu barədə “Yaşayış və qeyriyaşayış sahələrini təqdim edən şəxslərdən notariuslar tərəfindən ödəmə mənbəyində tutulan sadələşdirilmiş verginin bəyannaməsi” hesbat ayından sonrakı ayın 20-dən gec olmayaraq vergi orqanına təqdim edilir.</p>
      </div>

    </div>
  </div>
</template>

<script> 
  export default {
    data(){
      return {
        assignment: '1',
        zone: '4.0',
        area: '',
        price: ''
      }
    },    
    methods: {
      calc: function(){
        this.price = (15 * this.assignment * this.zone * this.area).toFixed(2) + ' AZN';
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/calc/Realestate.vue